import React from 'react'
import { Stack, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import './Field.sass'


function Field(props) {
  const { t } = useTranslation()

  const {
    multiline,
    minRows,
    label,
    placeholder = t('write'),
    direction = 'row',
    alignItems = "center",
    type = 'text',
    fullWidth = true,
    value,
    children,
    disabled = false,
    sx = {},
    onBlur = () => { },
    onChange = () => { },
    error = false,
    helperText = '',
  } = props

  return (
    <Stack
      className='Field'
      sx={sx}
      gap={2}
      direction={direction}
      justifyContent="space-between"
      alignItems={alignItems}
    >
      {label && <label>{label}</label>}
      <TextField
        disabled={disabled}
        size='small'
        multiline={multiline}
        minRows={minRows}
        fullWidth={fullWidth}
        variant="filled"
        value={value}
        type={type}
        label={placeholder}
        onChange={onChange}
        autoComplete="off"
        onBlur={onBlur}
        error={error}
        helperText={helperText}
      />
      {children}
    </Stack>
  )
}

export default Field